import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Colors } from '../theme';

export const StyledBox = styled(Box)(({ theme }) => ({
  // AddUserContainer
  '&.addUserContainer': {
    marginTop: '64px',
    padding: '1px',
  },

  // StyledCard
  '&.styledCard': {
    marginBottom: '24px',
    borderRadius: '16px',
    overflow: 'visible',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    "& button ,& lable":{
      backgroundColor:Colors.primary,
      color:"white",
      "&:hover":{
        backgroundColor:Colors.hover,
      }
    }
  },

  // CardHeader
  '&.cardHeader': {
    backgroundColor: Colors.primary,
    padding: '16px 24px',
    color: 'white',
    position: 'relative',
    zIndex: 1,
    borderRadius: '16px 16px 0 0',
  },

  // StyledTitle
  '&.styledTitle': {
    fontWeight: 600
  },

  // StyledSubTitle
  '&.styledSubTitle': {
    marginBottom: '16px',
    color: Colors.primary,
    fontWeight: 500
  },

  // UploadDescription
  '&.uploadDescription': {
    marginBottom: '16px'
  },

  // RequirementsTitle
  '&.requirementsTitle': {
    marginBottom: '8px'
  },

  // UploadTitle
  '&.uploadTitle': {
    marginBottom: '16px'
  },

  // UploadBox
  '&.uploadBox': {
    padding: '32px',
    border: '2px dashed '+Colors.border,
    borderRadius: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '300px',
    backgroundColor: '#f8f9fa',
    transition: 'all 0.3s ease',
    '&:hover': {
      borderColor: Colors.primary,
      backgroundColor: '#fff'
    },
    "& button , & label":{
      width:"fit-content",
      backgroundColor:Colors.primary,
      "&:hover":{
        backgroundColor:Colors.hover,
      }
    }
  },

  // RequirementsList
  '&.requirementsList': {
    backgroundColor: '#f8f9fa',
    padding: '20px',
    borderRadius: '12px',
    marginBottom: '24px',
    border: '1px solid ' + Colors.border,
    '& ul': {
      paddingLeft: '20px',
      margin: '8px 0',
      '& li': {
        marginBottom: '8px',
        color: Colors.garyText
      }
    }
  },

  // FileDetailsBox
  '&.fileDetailsBox': {
    marginBottom: '16px',
    textAlign: 'center'
  },

  // UploadButtonsContainer
  '&.uploadButtonsContainer': {
    display: 'flex',
    gap: '16px',
    marginTop: '16px',
  },

  // PreviewContainer
  '&.previewContainer': {
    marginTop: '24px',
    padding: '0 24px'
  },

  // TableContainer
  '&.tableContainer': {
    marginTop: '16px',
    maxHeight: '400px',
    '& .MuiTable-root': {
      borderCollapse: 'separate',
      borderSpacing: '0'
    }
  },

  // PreviewTitle
  '&.previewTitle': {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: Colors.primary,
    marginBottom: '16px'
  }
}));
